// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3P3od","title":"Header_title__1RKfj","left":"Header_left__1_-3G","clinicName":"Header_clinicName__3R1X8"};